<template class="productPrice">
  <div style="display: flex;flex-direction: row">
    <div class="custom-tree-container" style="width: 20%;overflow-x:scroll;white-space: nowrap; height: 85vh;">
      <el-input
          v-model="filterText"
          style="width: 200px; line-height: 50px; margin-bottom: 10px;"
          placeholder="输入关键字进行过滤"/>
      <div style="width:120%">
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="id"
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span style="font-size: 12px;" @click="tree(data)">{{data.label}}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <el-main style="padding:0;margin-left: 30px;width:100vh">
      <div style="margin-bottom: 10px;">
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
        <div class="vm-search" style="float: right;">
          <vm-search label="名称">
            <el-input v-model.trim="filter.materialName" clearable style="width: 300px;"/>
          </vm-search>
          <el-button
              :loading="status==='loading'"
              type="primary"
              size="mini"
              style="height: 26px; padding: 0 10px; margin-left: 10px;"
              @click="getList">
            查询
          </el-button>
        </div>
      </div>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          method="post"
          url="materials/pageList">
        <el-table-column prop="materialName" align="center" label="名称">
          <template slot-scope="scope">
            <span style="color: #2d8cf0;cursor: pointer;" @click="$refs.priceDetail.open(scope.row.materialID, scope.row.materialName)">
              {{scope.row.materialName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="规格" align="center" prop="specification"/>
        <el-table-column label="是否上架" align="center" prop="status" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="客户专用" align="center" prop="customerSpecial" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.customerSpecial === 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="价格申请类型" align="center" prop="priceApplicationType" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.priceApplicationType === 10" type="success">价格</el-tag>
            <el-tag v-else-if="scope.row.priceApplicationType === 20" type="danger">折扣</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否梯度报价" align="center" prop="isGradientPrice" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isGradientPrice" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否浮动价格" align="center" prop="isFloatPrice" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isFloatPrice" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
      </vm-table>
    </el-main>
    <price-detail ref="priceDetail"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import PriceDetail from "@/views/information/ProductPrice/PriceDetail";

  export default {
    name: "ProductPrice",
    components: {VmTable, VmSearch, PriceDetail},
    data() {
      return {
        constant,
        exportLoading: false,
        idList: "",
        filter: {
          materialName: "",
          materialID: "",
        },
        data: [],
        filterText: "",
        defaultProps: {
          children: "children",
          label: "",
          other: "",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getData();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getData() {
        this.$http
          .get("basic","materials/tree").then((res) => {
            this.data = res;
            this.data.unshift({id: -1, label: "全  部", level: 1, children: null, parentId: null});
          });
      },
      tree(data) {
        this.filter.materialID = data.id;
        this.getList(1);
      },
      filterNode(value, data, node) {
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","material_prices/export", null, 60 * 60 * 1000)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss">

</style>
